export enum ResourceType {
  ExportToExcel = 'exportToExcel',
  CreateNewTenant = 'createNewTenant',
  CreateNewUser = 'createNewUser',
  DeleteUser = 'deleteUser',
  GetUserRoles = 'getUserRoles',
  DeleteTenant = 'deleteTenant',
  CreateOpenAPIIntegration = 'createOpenAPIIntegration',
  Integrations = 'integrations',
  DeleteIntegration = 'deleteIntegration',
  UpdateOpenAPIIntegration = 'updateOpenAPIIntegration',
  GetOpenAPIIntegration = 'getOpenAPIIntegration',
  WebhookEvents = 'webhookEvents',
  AddWebhook = 'addWebhook',
  UpdateWebhook = 'updateWebhook',
  DeleteWebhook = 'deleteWebhook',
  ActivateWebhook = 'activateWebhook',
  DeactivateWebhook = 'deactivateWebhook',
  GetProduct = 'getProduct',
  GetMasterCarton = 'getMasterCarton',
  WorkflowsListApplicationEvents = 'workflowsListApplicationEvents',
  WorkflowsGetByEventType = 'workflowsGetByEventType',
  CreateWorkflow = 'createWorkflow',
  GetInstalledPrinters = 'getInstalledPrinters',
  GetInbound = 'getInbound',
  GetPurchaseOrder = 'getPurchaseOrder',
  CreateOperation = 'createOperation',
  GetOperations = 'getOperations',
  UpdateSingleItemFastPackThreshold = 'updateSingleItemFastPackThreshold',
  CheckOperationCargoPackageTypeBarcode = 'checkOperationCargoPackageTypeBarcode',
  GetSalesOrderState = 'getSalesOrderState',
  CreatePackingProcess = 'createPackingProcess',
  CreateHovPackingProcess = 'createHovPackingProcess',
  CreatePackingQuarantineProcess = 'createPackingQuarantineProcess',
  CreateHovPackingQuarantineProcess = 'createHovPackingQuarantineProcess',
  PrintVAS = 'printVAS',
  HOVPrintVAS = 'HOVprintVAS',
  CompletePackingProcess = 'completePackingProcess',
  CompleteHovPackingProcess = 'completeHovPackingProcess',
  PrintSLAMDocuments = 'printSLAMDocuments',
  HOVPrintSLAMDocuments = 'HOVprintSLAMDocuments',
  PrintCargoPackageLabels = 'printCargoPackageLabels',
  PrintHovCargoPackageLabels = 'printHovCargoPackageLabels',
  CompletePackingQuarantineProcess = 'completePackingQuarantineProcess',
  CompleteHovPackingQuarantineProcess = 'completeHovPackingQuarantineProcess',
  AssignQuarantineTote = 'assignQuarantineTote',
  AssignHovQuarantineTote = 'assignHovQuarantineTote',
  UnassignQuarantineTote = 'unassignQuarantineTote',
  UnassignHovQuarantineTote = 'unassignHovQuarantineTote',
  AddCargoPackage = 'addCargoPackage',
  AddHovCargoPackage = 'addHovCargoPackage',
  CloseCargoPackage = 'closeCargoPackage',
  UnsealCargoPackage = 'unsealCargoPackage',
  RemoveCargoPackage = 'removeCargoPackage',
  RemoveHovCargoPackage = 'removeHovCargoPackage',
  QueueItemIntoCargoPackage = 'queueItemIntoCargoPackage',
  QueueHovItemIntoCargoPackage = 'queueHovItemIntoCargoPackage',
  QueueItemIntoQuarantineTote = 'queueItemIntoQuarantineTote',
  QueueHovItemIntoQuarantineTote = 'queueHovItemIntoQuarantineTote',
  GetOperatorsByFullName = 'getOperatorsByFullName',
  PrintTestPage = 'PrintTestPage',
  GetSalesOrdersOperationCount = 'getSalesOrdersOperationCount',
  GetOrderTrackingReportSeries = 'getOrderTrackingReportSeries',
  GetSalesOrdersCreated = 'getSalesOrdersCreated',
  GetSalesOrdersPicking = 'getSalesOrdersPicking',
  GetSalesOrdersSorting = 'getSalesOrdersSorting',
  GetSalesOrdersPacking = 'getSalesOrdersPacking',
  GetSalesOrdersDispatch = 'getSalesOrdersDispatch',
  GetSalesOrdersSLAM = 'getSalesOrdersSLAM',
  GetSalesOrdersDelivered = 'getSalesOrdersDelivered',
  GetSalesOrdersCancelled = 'getSalesOrdersCancelled',
  GetSalesOrderStateDetail = 'getSalesOrderStateDetail',
  RecipientAddressDetails = 'recipientAddressDetails',
  ListCargoPackages = 'listCargoPackages',
  ListReturnPackages = 'listReturnPackages',
  SearchSalesOrders = 'searchSalesOrders',
  GetCargoCarriers = 'getCargoCarriers',
  UpdateTrackingInfo = 'updateTrackingInfo',
  SelectToteForReturnProcess = 'selectToteForReturnProcess',
  GetSalesOrderDetails = 'getSalesOrderDetails',
  CreateReturnProcessIfNotExist = 'createReturnProcessIfNotExist',
  SelectSalesOrderForReturn = 'selectSalesOrderForReturn',
  CompleteReturnProcess = 'completeReturnProcess',
  GetArrivedReturnPackages = 'getArrivedReturnPackages',
  GetInProcessReturnPackages = 'getInProcessReturnPackages',
  GetResolvedReturnPackages = 'getResolvedReturnPackages',
  GetUndefinedReturnPackages = 'getUndefinedReturnPackages',
  GetReturnPackageStateDetail = 'getReturnPackageStateDetail',
  ReturnPackageDetails = 'returnPackageDetails',
  ListOperationsByProductBarcodes = 'listOperationsByProductBarcodes',
  CreateUndefinedReturnPackage = 'createUndefinedReturnPackage',
  PreReceivingRecordDetails = 'preReceivingRecordDetails',
  PutAwayRecordDetails = 'putAwayRecordDetails',
  PickingRecordDetails = 'pickingRecordDetails',
  WaybillDetails = 'waybillDetails',
  CompleteWaybill = 'completeWaybill',
  CompleteOrder = 'completeOrder',
  GetInventoryItemsCount = 'getInventoryItemsCount',
  GetStockItemsCount = 'getStockItemsCount',
  GetOutOfStockItemsCount = 'getOutOfStockItemsCount',
  GetLineItemCountsByPurchaseOrder = 'getLineItemCountsByPurchaseOrder',
  GetPurchaseOrderDetails = 'getPurchaseOrderDetails',
  GetInventoryStatusByProduct = 'getInventoryStatusByProduct',
  QuarantineItemCounts = 'quarantineItemCounts',
  DeleteWorkflow = 'deleteWorkflow',
  GetWaitingForSLAMCargoPackagesCount = 'getWaitingForSLAMCargoPackagesCount',
  GetReadyToShipCargoPackagesCount = 'getReadyToShipCargoPackagesCount',
  WaitingForSLAMCargoPackages = 'waitingForSLAMCargoPackages',
  ReadyToShipCargoPackages = 'readyToShipCargoPackages',
  PrintCargoPackageCarrierLabel = 'printCargoPackageCarrierLabel',
  ListCarriers = 'listCarriers',
  ShipmentDetails = 'shipmentDetails',
  DispatchManagementCounts = 'dispatchManagementCounts',
  GetAddressType = 'getAddressType',
  GetDispatchProcessDetails = 'getDispatchProcessDetails',
  GetPickingTrolleyDetails = 'getPickingTrolleyDetails',
  GetBarcodeType = 'getBarcodeType',
  GetSalesOrderProblemDetails = 'getSalesOrderProblemDetails',
  GetCreatedProblems = 'getCreatedProblems',
  GetInProgressProblems = 'getInProgressProblems',
  GetResolvedProblems = 'getResolvedProblems',
  GetPickingProblemsAnalytics = 'getPickingProblemsAnalytics',
  GetDispatchProblemsAnalytics = 'getDispatchProblemsAnalytics',
  GetWallInventoryAnalytics = 'getWallInventoryAnalytics',
  CreateMissingCargoPackageLabelProblem = 'createMissingCargoPackageLabelProblem',
  CreateMissingSLAMLabelProblem = 'createMissingSLAMLabelProblem',
  CreateCargoCarrierPreferenceProblem = 'createCargoCarrierPreferenceProblem',
  GetProblemDetails = 'getProblemDetails',
  GetWrongShippingAddressProblemDetails = 'getWrongShippingAddressProblemDetails',
  SolveWrongShippingAddressProblem = 'SolveWrongShippingAddressProblem',
  GetCargoCarrierQuotaProblemDetails = 'getCargoCarrierQuotaProblemDetails',
  SolveCargoCarrierQuotaProblem = 'solveCargoCarrierQuotaProblem',
  GetMissingCargoPackageLabelProblemDetails = 'getMissingCargoPackageLabelProblemDetails',
  SolveMissingCargoPackageLabelProblem = 'solveMissingCargoPackageLabelProblem',
  GetMissingSLAMLabelProblemDetails = 'getMissingSLAMLabelProblemDetails',
  SolveMissingSLAMLabelProblem = 'solveMissingSLAMLabelProblem',
  GetSLAMShipmentProblemDetails = 'getSLAMShipmentProblemDetails',
  SolveSLAMShipmentProblem = 'solveSLAMShipmentProblem',
  GetCargoCarrierPreferenceProblemDetails = 'getCargoCarrierPreferenceProblemDetails',
  SolveCargoCarrierPreferenceProblem = 'solveCargoCarrierPreferenceProblem',
  GetMarketplaceCargoCarrierQuotaProblemDetails = 'getMarketplaceCargoCarrierQuotaProblemDetails',
  SolveMarketplaceCargoCarrierQuotaProblem = 'solveMarketplaceCargoCarrierQuotaProblem',
  GetIntegrationCodeProblemDetails = 'getIntegrationCodeProblemDetails',
  SolveIntegrationCodeProblem = 'SolveIntegrationCodeProblem',
  GetZoneDetails = 'getZoneDetails',
  GetInboundProblemsAnalytics = 'getInboundProblemsAnalytics',
  GetLostItemProblemDetails = 'getLostItemProblemDetails',
  GetInboundBarcodeType = 'getInboundBarcodeType',
  GetInboundProblemsByQuarantineContainerOrInboundBox = 'getInboundProblemsByQuarantineContainerOrInboundBox',
  GetInboundProblemDetails = 'getInboundProblemDetails',
  GetBarcodeMismatchProblemDetails = 'getBarcodeMismatchProblemDetails',
  SolveBarcodeMismatchProblem = 'solveBarcodeMismatchProblem',
  GetBarcodeNotExistProblemDetails = 'getBarcodeNotExistProblemDetails',
  SolveBarcodeNotExistProblem = 'solveBarcodeNotExistProblem',
  GetDamagedItemsProblemDetails = 'getDamagedItemsProblemDetails',
  SolveDamagedItemsProblem = 'solveDamagedItemsProblem',
  GetDuplicateBarcodeProblemDetails = 'getDuplicateBarcodeProblemDetails',
  SolveDuplicateBarcodeProblem = 'solveDuplicateBarcodeProblem',
  GetUnidentifiedProductProblemDetails = 'getUnidentifiedProductProblemDetails',
  SolveUnidentifiedProductProblem = 'solveUnidentifiedProductProblem',
  GetUnreadableBarcodeProblemDetails = 'getUnreadableBarcodeProblemDetails',
  SolveUnreadableBarcodeProblem = 'solveUnreadableBarcodeProblem',
  GetPickListDetails = 'getPickListDetails',
  SetPickingTrolleySelectionConfigurationStatus = 'setPickingTrolleySelectionConfigurationStatus',
  PrioritizeSalesOrders = 'prioritizeSalesOrders',
  PrioritizeAllSalesOrders = 'prioritizeAllSalesOrders',
  RemovePickingPriorities = 'removePickingPriorities',
  SalesOrderGetPickListDetails = 'salesOrderGetPickListDetails',
  GetPutAwayManagementCounts = 'getPutAwayManagementCounts',
  GetPutAwayTrolleyDetails = 'getPutAwayTrolleyDetails',
  GetPutAwayToteDetails = 'getPutAwayToteDetails',
  PlaceQuarantineToteToQuarantineAddress = 'placeQuarantineToteToQuarantineAddress',
  PlaceHovQuarantineToteToQuarantineAddress = 'placeHovQuarantineToteToQuarantineAddress',
  GetTransferTrolleyDetails = 'getTransferTrolleyDetails',
  GetMissingItemSalesOrderState = 'getMissingItemSalesOrderState',
  CreateMissingItemTransferProcess = 'createMissingItemTransferProcess',
  GetQuarantineToteDetails = 'getQuarantineToteDetails',
  CompleteMissingItemTransfer = 'completeMissingItemTransfer',
  CompleteWithLostItemMissingItemTransfer = 'completeWithLostItemMissingItemTransfer',
  CompleteCancelledMissingItemTransfer = 'completeCancelledMissingItemTransfer',
  CheckQuarantineToteMissingItemTransfer = 'checkQuarantineToteMissingItemTransfer',
  CreateToteSingleItemPackingProcessIfNotExists = 'createToteSingleItemPackingProcessIfNotExists',
  GetSingleItemSalesOrderState = 'getSingleItemSalesOrderState',
  CreateSalesOrderPackingProcessIfNotExists = 'createSalesOrderPackingProcessIfNotExists',
  CompleteSalesOrderPackingProcess = 'completeSalesOrderPackingProcess',
  GetSingleItemSalesOrdersToteRemainingItems = 'getSingleItemSalesOrdersToteRemainingItems',
  CompleteToteSingleItemPackingProcess = 'completeToteSingleItemPackingProcess',
  CompleteSingleItemPackingQuarantineProcess = 'completeSingleItemPackingQuarantineProcess',
  PrintSingleItemSalesOrderCargoPackageLabels = 'printSingleItemSalesOrderCargoPackageLabels',
  PrintSingleItemSalesOrderVAS = 'printSingleItemSalesOrderVAS',
  PrintSLAMDocumentsOnSingleItemSalesOrderPacking = 'printSLAMDocumentsOnSingleItemSalesOrderPacking',
  GetSingleItemRemainingToteSalesOrdersCount = 'getSingleItemRemainingToteSalesOrdersCount',
  PrioritizeStockCountingPlan = 'PrioritizeStockCountingPlan',
  DeprioritizeStockCountingPlan = 'DeprioritizeStockCountingPlan',
  GetStockCountingPlanDetails = 'getStockCountingPlanDetails',
  GetPendingCellStockCountingPlanDetails = 'getPendingCellStockCountingPlanDetails',
  GetPendingItemStockCountingPlanDetails = 'getPendingItemStockCountingPlanDetails',
  CreateStockCountingPlan = 'createStockCountingPlan',
  ReceivingOperationsCounts = 'receivingOperationsCounts',
  GetTrolleyStatus = 'getTrolleyStatus',
  GetToteStatus = 'getToteStatus',
  GetCellStatus = 'getCellStatus',
  StockCountingListDetails = 'stockCountingListDetails',
  PendingStockCountingListDetails = 'pendingStockCountingListDetails',
  StockCountingStatistics = 'stockCountingStatistics',
  StockStatusCounts = 'stockStatusCounts',
  GetInboundBoxDetails = 'getInboundBoxDetails',
  CreatePackageInboundStationIfNotExists = 'createIfNotExists',
  SelectReceivingTote = 'selectReceivingTote',
  SelectQuarantineTote = 'selectQuarantineTote',
  CheckBarcodeType = 'checkBarcodeType',
  PlaceItemToReceivingTote = 'placeItemToReceivingTote',
  PlaceItemToQuarantineTote = 'placeItemToQuarantineTote',
  DropTote = 'dropTote',
  InboundPackageComplete = 'complete',
  AddOrUpdateCargoPackageToQueueForSingleItemPacking = 'addOrUpdateCargoPackageToQueueForSingleItemPacking',
  DeleteCargoPackageFromQueueForSingleItemPacking = 'deleteCargoPackageFromQueueForSingleItemPacking',
  SetStockCountingListConfigurationStatus = 'setStockCountingListConfigurationStatus',
  ContinueIfTotesExistsOnReceivingAddress = 'continueIfTotesExistsOnReceivingAddress',
  QuerySalesOrderNotes = 'querySalesOrderNotes',
  CreateSalesOrderNote = 'createSalesOrderNote',
  DispatchPackagesCounts = 'dispatchPackagesCounts',
  ReservedProductManagementCounts = 'queryReservedProductManagementCounts',
  ExpirationDateTrackingCounts = 'getInventoryItemExpirationDateTrackingCounts',
  PackageDetails = 'packageDetails',
  GetHOVSalesOrderState = 'getHOVSalesOrderState',
  CheckProductBarcode = 'checkProductBarcode',
  CheckReturnItemSerialNumber = 'checkReturnItemSerialNumber',
  SerialNumberTracking = 'serialNumberTracking',
  PrintHOVPalettePackingList = 'printHOVPalettePackingList',
  PrintPalettePackingList = 'printPalettePackingList',
  PrintUnprintedHOVPalettePackingList = 'printUnprintedHOVPalettePackingList',
  PrintUnprintedPalettePackingList = 'printUnprintedPalettePackingList',
  ReprintHOVPalettePackingList = 'reprintHOVPalettePackingList',
  ReprintPalettePackingList = 'reprintPalettePackingList',
  CheckSimpleSerialNumber = 'checkSimpleSerialNumber',
  CheckSimpleSerialNumberForSinglePacking = 'checkSimpleSerialNumberForSinglePacking',
  CheckHOVSimpleSerialNumber = 'checkHOVSimpleSerialNumber',
  RemovePackingQuarantineProcess = 'removePackingQuarantineProcess',
  PreviewManualPicklist = 'previewManualPicklist',
  CreateManualPicklist = 'createManualPicklist',
  GetManualPicklistCargoCarrierNames = 'getManualPicklistCargoCarrierNames',
  GetSubZones = 'getSubZones',
  QueryManualPicklistsByExcludeSkus = 'queryManualPicklistsByExcludeSkus',
  DeletePickLists = 'deletePickLists',
  GetCargoCodeUpdatedProblemDetails = 'getCargoCodeUpdatedProblemDetails',
  SolveCargoCodeUpdatedProblem = 'solveCargoCodeUpdatedProblem',
  PalletsGetSummary = 'palletsGetSummary',
  CheckWaitingPallets = 'checkWaitingPallets',
  BatchPickingProcessGetConfig = 'batchPickingProcessGetConfig',
  BatchPickingProcessUpsertConfig = 'batchPickingProcessUpsertConfig',
  RebinSortingCheckBatchTrolley = 'rebinSortingCheckBatchTrolley',
  RebinSortingStartSortingProcess = 'rebinSortingStartSortingProcess',
  RebinSortingAssignRebinTrolley = 'rebinSortingAssignRebinTrolley',
  RebinSortingCheckBatchPickingTote = 'rebinSortingCheckBatchPickingTote',
  RebinSortingGetBatchPickingToteDetails = 'rebinSortingGetBatchPickingToteDetails',
  RebinSortingGetAllBatchPickingToteDetails = 'rebinSortingGetAllBatchPickingToteDetails',
  RebinSortingCheckBatchPickingProduct = 'rebinSortingCheckBatchPickingProduct',
  RebinSortingPlaceProduct = 'rebinSortingPlaceProduct',
  RebinSortingDropAllBatchTotes = 'rebinSortingDropAllBatchTotes',
  RebinSortingDropAllBatchTotesWithLostItems = 'rebinSortingDropAllBatchTotesWithLostItems',
  RebinSortingDropRebinTrolley = 'rebinSortingDropRebinTrolley',
  PickListRequestsDelete = 'pickListRequestsDelete',
  PickListRequestsPrioritize = 'pickListRequestsPrioritize',
  GetPickListRequestStateDetails = 'getPickListRequestStateDetails',
  WarehouseConfig = 'warehouseConfig',
  GetWallToWallStockCountingCounts = 'getWallToWallStockCountingCounts',
  CheckWallToWallStockCountingPlanNameIfAvailable = 'checkWallToWallStockCountingPlanNameIfAvailable',
  AssignToWallToWallStockCountingPlan = 'assignToWallToWallStockCountingPlan',
  DeleteWallToWallStockCountingList = 'deleteWallToWallStockCountingList',
  DeleteWallToWallStockCountingAddress = 'deleteWallToWallStockCountingAddress',
  StartWallToWallStockCountingPlan = 'startWallToWallStockCountingPlan',
  GetActiveWallToWallStockCountingPlans = 'getActiveWallToWallStockCountingPlans',
  GetCompletedWallToWallStockCountingPlans = 'getCompletedWallToWallStockCountingPlans',
  GetWallToWallStockCountingTrackingCounts = 'getWallToWallStockCountingTrackingCounts',
  AssignNewAddressesToPlan = 'assignNewAddressesToPlan',
  FinishWallToWallStockCountingPlan = 'finishWallToWallStockCountingPlan',
  CreateListForIncorrectCountedCells = 'createListForIncorrectCountedCells',
  GetCreatedStateWallToWallStockCountingLists = 'getCreatedStateWallToWallStockCountingLists',
  GetWallToWallStockCountingReportCounts = 'getWallToWallStockCountingReportCounts',
  QueryWallToWallStockCountingSummaryReport = 'queryWallToWallStockCountingSummaryReport',
  GetCreatedWallToWallStockCountingPlans = 'getCreatedWallToWallStockCountingPlans',
  ApplyWallToWallStockCountingPlanToStock = 'applyWallToWallStockCountingPlanToStock',
  PrintAdditionalCargoPackageLabels = 'printAdditionalCargoPackageLabels',
  HOVPrintAdditionalCargoPackageLabels = 'HOVPrintAdditionalCargoPackageLabels',
  PickListRequestsGetBatchNextQrCode = 'pickListRequestsGetBatchNextQrCode',
  SimplePackingProcessCheckPackingProcessExists = 'simplePackingProcessCheckPackingProcessExists',
  SimplePackingProcessCreatePackingProcess = 'simplePackingProcessCreatePackingProcess',
  SimplePackingProcessQueueItemsIntoCargoPackage = 'simplePackingProcessQueueItemsIntoCargoPackage',
  SimplePackingProcessAddCargoPackage = 'simplePackingProcessAddCargoPackage',
  SimplePackingProcessCompletePackingProcess = 'simplePackingProcessCompletePackingProcess',
  SimplePackingProcessPrintCargoPackageLabels = 'simplePackingProcessPrintCargoPackageLabels',
  SimplePackingProcessPrintSLAMDocuments = 'simplePackingProcessPrintSLAMDocuments',
  NpsMatch = 'npsMatch',
  RasCheckBarcodeType = 'rasCheckBarcodeType',
  RasStowCheckTote = 'rasStowCheckTote',
  RasStowPlaceTote = 'rasStowPlaceTote',
  RasStowCheckProduct = 'rasStowCheckProduct',
  RasStowDivertCancelledItem = 'rasStowDivertCancelledItem',
  RasCheckCell = 'rasCheckCell',
  RasStowPlaceProduct = 'rasStowPlaceProduct',
  RasStowDirectCheckProduct = 'rasStowDirectCheckProduct',
  RasStowDirectPlaceProduct = 'rasStowDirectPlaceProduct',
  RasStowDropTote = 'rasStowDropTote',
  RasReleasePod = 'rasReleasePod',
  RasStowCloseStation = 'rasStowCloseStation',
  RasPickCheckTote = 'rasPickCheckTote',
  RasPickPlaceTote = 'rasPickPlaceTote',
  RasPickCheckProduct = 'rasPickCheckProduct',
  RasPickPlaceProduct = 'rasPickPlaceProduct',
  RasPickDropTote = 'rasPickDropTote',
  RasPickCloseStation = 'rasPickCloseStation',
  RasStationTotes = 'rasStationTotes',
  RasPickLostItem = 'rasPickLostItem',
  RasPickStationMetric = 'rasPickStationMetric',
  RasStowStationMetric = 'rasStowStationMetric',
  RasOrderBasedPickCheckTrolley = 'rasOrderBasedPickCheckTrolley',
  RasOrderBasedPickStationTrolleys = 'rasOrderBasedPickStationTrolleys',
  RasOrderBasedPickPlaceTrolleys = 'rasOrderBasedPickPlaceTrolleys',
  RasOrderBasedPickCheckProduct = 'rasOrderBasedPickCheckProduct',
  RasOrderBasedPickPlaceProduct = 'rasOrderBasedPickPlaceProduct',
  RasOrderBasedPickMissingItem = 'rasOrderBasedPickMissingItem',
  RasOrderBasedPickCancelledItem = 'rasOrderBasedPickCancelledItem',
  RasOrderBasedPickCluster = 'rasOrderBasedPickCluster',
  // RasOrderBasedPickGetSessionHistory = 'rasOrderBasedPickGetSessionHistory',
  RasProblemSolverPodMissingItems = 'rasProblemSolverPodMissingItems',
  RasProblemSolverPodPendingCancellations = 'rasProblemSolverPodPendingCancellations',
  RasProblemSolverStripCancelledItem = 'rasProblemSolverStripCancelledItem',
  RasProblemSolverCallPod = 'rasProblemSolverCallPod',
  RasProblemSolverItemFound = 'rasProblemSolverItemFound',
  RasProblemSolverItemLost = 'rasProblemSolverItemLost',
  GetTenantConfigurationsByTenantId = 'getTenantConfigurationsByTenantId',
  RebinSortingGetAllRebinSortingHistory = 'rebinSortingGetAllRebinSortingHistory',
  RebinSortingCheckAndPlaceBatchPickingProduct = 'rebinSortingCheckAndPlaceBatchPickingProduct',
  GetTotePackingType = 'getTotePackingType',
  GetHOVTotePackingType = 'getHOVTotePackingType',
  GetSingleItemTotePackingType = 'getSingleItemTotePackingType',
  PrintApprovedCargoPackageCarrierLabel = 'printApprovedCargoPackageCarrierLabel',
  ProblemSolverQueryMissingOrdersCounts = 'problemSolverQueryMissingOrdersCounts',
  RemoveItemFromCargoPackage = 'removeItemFromCargoPackage',
  RemoveHovItemFromCargoPackage = 'removeHovItemFromCargoPackage',
  RemovePackingProcessOfUnpackableTote = 'removePackingProcessOfUnpackableTote',
  RemoveHOVPackingProcessOfUnpackableTote = 'removeHOVPackingProcessOfUnpackableTote',
  GetSingleItemFastPackTotePackingType = 'getSingleItemFastPackTotePackingType',
  CreateToteSingleItemFastPackPackingProcessIfNotExists = 'createToteSingleItemFastPackPackingProcessIfNotExists',
  AddCargoPackagesAndPrintCargoPackageLabels = 'addCargoPackagesAndPrintCargoPackageLabels',
  CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcess = 'completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcess',
  PrintSingleItemFastPackSalesOrderCargoPackageLabels = 'printSingleItemFastPackSalesOrderCargoPackageLabels',
  CompleteSingleItemFastPackPackingQuarantineProcess = 'completeSingleItemFastPackPackingQuarantineProcess',
  QueryTotesReadyToPack = 'queryTotesReadyToPack',
  GetWaybillStationInfo = 'getWaybillStationInfo',
  GetCustomActionVASTypes = 'getCustomActionVASTypes',
  AddCustomActionVasToSalesOrder = 'addCustomActionVasToSalesOrder',
  PrintWaybillDocument = 'printWaybillDocument',
  MarkWaybillAsPrinted = 'markWaybillAsPrinted',
  GetUnprintedWaybillOrders = 'getUnprintedWaybillOrders',
}
